<template>
  <v-app>
    <v-app-bar
        app
        color="primary"
        dark
    >
      <v-expand-transition v-if="$store.state.loggedIn">
        <v-app-bar-nav-icon @click.stop="drawer = (!drawer && $store.state.loggedIn)"></v-app-bar-nav-icon>
      </v-expand-transition>
      <v-toolbar-title class="d-flex">
          <img :src="require('@/assets/logo-icon-white.svg')" width="32" height="32" />
          <span class="ml-2">Torvue</span>
      </v-toolbar-title>
    </v-app-bar>
    <v-navigation-drawer
        v-model="drawer"
        fixed
        clipped
        temporary
        app
    >
      <v-list dense>

        <v-list-item @click="$router.push('/login')" v-if="!$store.state.loggedIn">
          <v-list-item-action>
            <v-icon>mdi-account-plus</v-icon>
          </v-list-item-action>
          <v-list-item-content>
            <v-list-item-title>
              Sign Up
            </v-list-item-title>
          </v-list-item-content>
        </v-list-item>

        <v-list-item @click="$router.push('/login')" v-if="!$store.state.loggedIn">
          <v-list-item-action>
            <v-icon>mdi-login</v-icon>
          </v-list-item-action>
          <v-list-item-content>
            <v-list-item-title>
              Login
            </v-list-item-title>
          </v-list-item-content>
        </v-list-item>

        <v-list-item @click="$router.push('/home')" v-if="$store.state.loggedIn" :disabled="$route.path === '/' || $route.path === '/home'">
          <v-list-item-action>
            <v-icon>mdi-home</v-icon>
          </v-list-item-action>
          <v-list-item-content>
            <v-list-item-title>
              Home
            </v-list-item-title>
          </v-list-item-content>
        </v-list-item>

        <v-list-item @click="$router.push('/checklist')" v-if="$store.state.loggedIn" :disabled="$route.path === '/checklist'">
          <v-list-item-action>
            <v-icon>mdi-checkbox-marked</v-icon>
          </v-list-item-action>
          <v-list-item-content>
            <v-list-item-title>
              Prerecord Checklist
            </v-list-item-title>
          </v-list-item-content>
        </v-list-item>

        <v-list-item @click="$router.push('/learn')" v-if="$store.state.loggedIn" :disabled="$route.path === '/learn'">
          <v-list-item-action>
            <v-icon>mdi-school</v-icon>
          </v-list-item-action>
          <v-list-item-content>
            <v-list-item-title>
              Get Started
            </v-list-item-title>
          </v-list-item-content>
        </v-list-item>

        <v-list-item @click="$router.push('/team')" v-if="$store.state.loggedIn" :disabled="$route.path === '/team'">
          <v-list-item-action>
            <v-icon>mdi-account-plus</v-icon>
          </v-list-item-action>
          <v-list-item-content>
            <v-list-item-title>
              Team
            </v-list-item-title>
          </v-list-item-content>
        </v-list-item>

        <v-list-item @click="$router.push('/branding')" v-if="$store.state.loggedIn" :disabled="$route.path === '/branding'">
          <v-list-item-action>
            <v-icon>mdi-account-details</v-icon>
          </v-list-item-action>
          <v-list-item-content>
            <v-list-item-title>
              Branding
            </v-list-item-title>
          </v-list-item-content>
        </v-list-item>

        <v-list-item @click="$router.push('/account')" v-if="$store.state.loggedIn" :disabled="$route.path === '/account'">
          <v-list-item-action>
            <v-icon>mdi-account-circle</v-icon>
          </v-list-item-action>
          <v-list-item-content>
            <v-list-item-title>
              Account
            </v-list-item-title>
          </v-list-item-content>
        </v-list-item>

<!--        <v-list-item-->
<!--            v-if="$route.path !== '/account' && $store.state.loggedIn && $store.state.account && $store.state.account.subscribed"-->
<!--            @click="$router.push({-->
<!--        path: '/account',-->
<!--        query: {-->
<!--          buyCamera: true-->
<!--        }-->
<!--        })">-->
<!--          <v-list-item-action>-->
<!--            <v-icon>mdi-camera</v-icon>-->
<!--          </v-list-item-action>-->
<!--          <v-list-item-content>-->
<!--            <v-list-item-title>-->
<!--              Buy Camera Bundle-->
<!--            </v-list-item-title>-->
<!--          </v-list-item-content>-->
<!--        </v-list-item>-->

        <v-list-item @click="logout" v-if="$store.state.loggedIn">
          <v-list-item-action>
            <v-icon v-if="!loggingOut">mdi-logout</v-icon>
            <v-progress-circular indeterminate v-else></v-progress-circular>
          </v-list-item-action>
          <v-list-item-content>
            <v-list-item-title>
              Logout
            </v-list-item-title>
          </v-list-item-content>
        </v-list-item>
      </v-list>
    </v-navigation-drawer>

    <v-main>
      <div class="d-flex justify-center align-center flex-column" v-if="loadingRoutes">
        <v-progress-circular class="ma-5" :indeterminate="true" />
      </div>
      <router-view/>
    </v-main>
  </v-app>
</template>

<script>
import AuthService from "@/services/AuthService"

export default {
  name: 'App',

  data: () => ({
    drawer: false,
    loggingOut: false,
    loadingRoutes: true
  }),
  mounted() {
    const init = async () => {
      await AuthService.authCheck()
      this.loadingRoutes = false
    }
    init()
  },
  methods: {
    async logout() {
      this.loggingOut = true
      try {
        await AuthService.logout()
      } finally {
        this.loggingOut = false
      }
    }
  }
};
</script>

<style>
.swal2-popup {
  font-size: 1.0rem !important;
  font-family: "Roboto", sans-serif;
}

@media print {
  header {
    visibility: hidden;
  }
}

</style>
